import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import ProfileFormGrid from '../../base/ProfileFormGrid.styled';
import ProfileTextInput from '../../base/inputs/ProfileTextInput';
import ProfileSelectInput from '../../base/inputs/ProfileSelectInput';
import GridColumnPlaceholder from '../../base/GridColumnPlaceholder.styled';

import countries from '../../../../../../public/data/countries.json';

export default function PermanentAddressForm({ form, setForm }) {
  const { info, readonly } = useSelector(state => state.travelerProfile);

  const omittedCountryValues = ['Countries Vary', 'Stateless/Refuge/Other', 'Unspecified Location'];
  const countryOptions = countries.filter(country => !omittedCountryValues.includes(country.label));
  const [countryOptionList, setCountryOptionList] = useState([...countryOptions]);

  useEffect(() => {
    let newCountryOptionList = [...countryOptionList];

    if (info.permanent_address_country) {
      let country = countryOptionList.find(
        option => option.value === info.permanent_address_country || option.label === info.permanent_address_country,
      );
      if (!country) {
        newCountryOptionList = [
          ...newCountryOptionList,
          {
            id: Date.now(),
            label: info.permanent_address_country,
            value: info.permanent_address_country,
          },
        ];

        setCountryOptionList([...newCountryOptionList]);
      }
    }

    setForm({
      permanent_address_city: info.permanent_address_city,
      permanent_address_state: info.permanent_address_state,
      permanent_address_line_1: info.permanent_address_line_1,
      permanent_address_line_2: info.permanent_address_line_2,
      permanent_address_zip_code: info.permanent_address_zip_code,
      permanent_address_country:
        newCountryOptionList.find(country => country.value === info.permanent_address_country) || '',
    });
  }, [info]);

  return (
    <ProfileFormGrid>
      <ProfileTextInput
        id="permanent_address_line_1"
        className="col-span-2"
        label="Permanent Address"
        labelHelperText="(Street Address or P.O. Box)"
        placeholder="Enter permanent address"
        value={form.permanent_address_line_1}
        synced={readonly.includes('permanent_address_line_1')}
        handleOnChange={event => {
          setForm({ ...form, permanent_address_line_1: event.target.value });
        }}
      />
      <ProfileTextInput
        id="permanent_address_line_2"
        className="col-span-2"
        label="Address Line 2"
        placeholder="Enter address line 2"
        value={form.permanent_address_line_2}
        synced={readonly.includes('permanent_address_line_2')}
        handleOnChange={event => {
          setForm({ ...form, permanent_address_line_2: event.target.value });
        }}
      />
      <GridColumnPlaceholder />
      <ProfileTextInput
        id="permanent_address_city"
        label="City"
        placeholder="Enter city"
        value={form.permanent_address_city}
        synced={readonly.includes('permanent_address_city')}
        handleOnChange={event => {
          setForm({ ...form, permanent_address_city: event.target.value });
        }}
      />
      <ProfileTextInput
        id="permanent_address_state"
        label="State / Province / Territory"
        placeholder="Enter state / province / territory"
        value={form.permanent_address_state}
        synced={readonly.includes('permanent_address_state')}
        handleOnChange={event => {
          setForm({ ...form, permanent_address_state: event.target.value });
        }}
      />
      <GridColumnPlaceholder />
      <ProfileTextInput
        id="permanent_address_zip_code"
        label="Zip / Postal Code"
        placeholder="Enter zip / postal code"
        value={form.permanent_address_zip_code}
        synced={readonly.includes('permanent_address_zip_code')}
        handleOnChange={event => {
          setForm({ ...form, permanent_address_zip_code: event.target.value });
        }}
      />
      <ProfileSelectInput
        id="permanent_address_country"
        label="Country"
        placeholder="Select country"
        value={form.permanent_address_country}
        options={countryOptionList}
        synced={readonly.includes('permanent_address_country')}
        handleOnChange={event => {
          setForm({ ...form, permanent_address_country: event });
        }}
      />
    </ProfileFormGrid>
  );
}

PermanentAddressForm.propTypes = {
  form: PropTypes.shape({
    permanent_address_city: PropTypes.string,
    permanent_address_state: PropTypes.string,
    permanent_address_line_1: PropTypes.string,
    permanent_address_line_2: PropTypes.string,
    permanent_address_zip_code: PropTypes.string,
    permanent_address_country: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  }).isRequired,
  setForm: PropTypes.func.isRequired,
};
